import React from "react";
import { ComponentContainer } from "../styled.js";
import { ReleasesBg } from "../styled.js";
import { useLanguage } from "../i18n/LanguageContext";

const BANDCAMP_ALBUM_SRC =
  "https://bandcamp.com/EmbeddedPlayer/album=2811511511/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/";

const Releases = () => {
  const { t } = useLanguage();
  const vt = t.releases.videoTitles;

  return (
    <div id="music">
      <ReleasesBg>
        <ComponentContainer>
          <div className="bandcamp-player-wrap">
            <iframe
              className="bandcamp-player"
              src={BANDCAMP_ALBUM_SRC}
              title={t.releases.bandcampAlbumTitle}
              loading="lazy"
              allow="autoplay"
            />
          </div>
          <div className="video-container">
            <iframe
              className="video-frame"
              src="https://www.youtube.com/embed/_7VrGHMsNOw"
              allow="accelerometer; autoplay; encrypted-media; gyroscope"
              allowFullScreen
              title={vt.mustaKivi}
            />
            <iframe
              className="video-frame"
              src="https://www.youtube.com/embed/mubC_knDiFM"
              allow="accelerometer; autoplay; encrypted-media; gyroscope"
              allowFullScreen
              title={vt.kaikenKauniin}
            />
            <iframe
              className="video-frame"
              src="https://www.youtube.com/embed/ldJVrLexdB0?si=L4zla5uHvCkXUJxr"
              allow="accelerometer; autoplay; encrypted-media; gyroscope"
              allowFullScreen
              title={vt.vadelmagaalaLive}
            />
          </div>
        </ComponentContainer>
      </ReleasesBg>
    </div>
  );
};

export default Releases;
